export default __webpack_public_path__ + "static/media/face-id.b74a9dde.svg";